package com.eladfinish.bible.contest.screens.search.ui.menu

import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.rememberUpdatedState
import com.eladfinish.bible.contest.navigation.SearchScreenNavigationDestination
import com.eladfinish.bible.contest.navigation.screenKey
import com.eladfinish.bible.contest.screens.search.mvi.SearchAction
import com.eladfinish.bible.contest.ui.menus.actions.SearchToolbarAction
import com.eladfinish.bible.contest.ui.menus.viewModels.ToolbarActionBusViewModel

@Composable
fun SearchToolbarBindings(
    onAction: (SearchAction) -> Unit,
    toolbarActionBus: ToolbarActionBusViewModel,
) {
    val screenKey = SearchScreenNavigationDestination::class.screenKey

    val onDispatch by rememberUpdatedState<(SearchToolbarAction) -> Unit> { action ->
        onAction(
            SearchAction.ToolbarClicked(
                toolbarAction = action,
            ),
        )
    }

    LaunchedEffect(screenKey) {
        toolbarActionBus.setActiveScreenKey(screenKey)
        toolbarActionBus.events.collect { event ->
            if (event.screenKey != screenKey) return@collect

            val action = event.action as? SearchToolbarAction ?: return@collect

            onDispatch(action)
        }
    }
}
